import React from 'react';
import { useSnackbar } from 'react-simple-snackbar';

type Notification = {
  title?: string;
  message: string;
};

type UseNotificationResult = {
  showNotification: (notification: Notification) => void;
  hideNotification: () => void;
};

const LEVELS = {
  default: { backgroundColor: '#ffffff', color: '#959595' },
  error: { backgroundColor: '#ffffff', color: '#ed0b24' },
} as const;

type Level = keyof typeof LEVELS | undefined;

export const useNotification = (level?: Level): UseNotificationResult => {
  const style = LEVELS[level || 'default'];
  const [showNotification, hideNotification] = useSnackbar({ style });

  const handleShowNotification = ({ title, message }: Notification): void =>
    showNotification(
      <>
        {title && <h4 className="text-xl">{title}</h4>}

        <p className="text-sm">{message}</p>
      </>
    );

  return {
    showNotification: handleShowNotification,
    hideNotification,
  };
};
